import { useMediaQuery } from 'react-responsive';

import Marquee from 'src/components/marquee-slider/marquee-components/Marquee';

import GetCarouselCard from "@/src/components/wall-components/GetCarouselCard";
import { SOCIAL_CARD_TYPE, socialCardKeys } from "@/src/constants/socialcard.constant";
import { wallKeys,WIDGET_TYPE } from "@/src/constants/wall.constant";

import GetReviewTestimonialCard from '@/src/components/wall-components/widgetTypes/star-review-card/GetReviewTestimonialCard'
import GetBannerReviewCard from '@/src/components/wall-components/widgetTypes/banner-review-card/GetBannerReviewCard'
import GetGraphicCard from '@/src/components/wall-components/widgetTypes/graphic-card/GetGraphicCard'
import GetCleanReviewCard from '@/src/components/wall-components/widgetTypes/clean-review-card/GetCleanReviewCard'
import GetAwardReviewCard from "@/src/components/wall-components/widgetTypes/award-review-card/GetAwardReviewCard";
import GetQuoteTextReviewCard from "@/src/components/wall-components/widgetTypes/quote-text-review-card/GetQuoteTextReviewCard";
import GetGreyColoredCard from "@/src/components/wall-components/widgetTypes/grey-colored-card/GetGreyColoredCard";
import { getStudioRenderer } from "@/src/components/wall-components/widgetTypes/studio-cards";
import { ReadMoreTextContext } from "@/src/components/componentHelper/ReadMoreReadLess";

const MarqueeSlider = ({ firstBatch, secondBatch, wall, refresh = () => {} }) => {
  const isCompactViewport = useMediaQuery({ maxWidth: 768 });
  const itemSpacing = isCompactViewport ? 12 : 24;
  const rowSpacing = isCompactViewport ? 18 : 28;
  const cardMaxWidth = isCompactViewport ? '20rem' : '28rem';

  const getSourceVideoCardWidth = (cardItem) => {
    if (!cardItem || cardItem[socialCardKeys.socialCardType] !== SOCIAL_CARD_TYPE.VIDEO || !cardItem[socialCardKeys.sourcePlatform]) {
      return null;
    }

    if (cardItem[socialCardKeys.sourcePlatform] === 'tiktok') {
      return isCompactViewport ? '18rem' : '21rem';
    }

    return isCompactViewport ? '20rem' : '28rem';
  };

  const renderCardItem = (cardItem) => {
    const sourceVideoCardWidth = getSourceVideoCardWidth(cardItem);
    const cardWidth = sourceVideoCardWidth || "auto";
    const cardStyle = sourceVideoCardWidth
      ? { marginRight: `${itemSpacing}px`, width: sourceVideoCardWidth, maxWidth: sourceVideoCardWidth }
      : { marginRight: `${itemSpacing}px`, maxWidth: cardMaxWidth };

    return (
      <div
        key={cardItem[socialCardKeys.uuid]}
        id={cardItem[socialCardKeys.uuid]}
        className="flex"
        style={cardStyle}
      >
        <ReadMoreTextContext.Provider
          value={{
            readMoreText: wall[wallKeys.readMoreText],
            readLessText: wall[wallKeys.readLessText]
          }}
        >
          {renderWidget({
            socialCardType: cardItem[socialCardKeys.socialCardType],
            cardWidth,
            cardItem: cardItem,
            darkModeEnabled: wall[wallKeys.isDarkModeEnabled],
            cardFontColor: wall[wallKeys.cardFontColor],
            linkColor: wall[wallKeys.linkColor],
            highlightColor: wall[wallKeys.highlightColor],
            cardBackgroundObject: wall[wallKeys.cardBackgroundObject],
            darkCardTheme: wall[wallKeys.darkCardTheme],
            engagementDisabled: wall[wallKeys.isEngagementDisabled],
            smallSize: wall[wallKeys.isSmallSize],
            shortenText: wall[wallKeys.shortenText],
            isDateTimeDisabled: wall[wallKeys.isDateTimeDisabled],
            quotationColor: wall[wallKeys.quotationColor],
            bandColor: wall[wallKeys.bandColor],
            inkColor: wall[wallKeys.inkColor],
            scoreBlockColor: wall[wallKeys.scoreBlockColor],
            ratingColor: wall[wallKeys.ratingColor],
            refresh,
            fontStyle: wall[wallKeys.fontStyle]
          })}
        </ReadMoreTextContext.Provider>
      </div>
    );
  };

  const renderWidget =(widgetProps) => {
    /* Studio card set (types 10-19). One lookup instead of ten branches;
       returns null for every older type, which then falls through below. */
    const studioRenderer = getStudioRenderer(wall[wallKeys.widgetType]);
    if (studioRenderer) {
      return studioRenderer({ ...widgetProps });
    }


    if(wall[wallKeys.widgetType]===WIDGET_TYPE.CENTRE_REVIEW_TYPE){
      return  GetReviewTestimonialCard({ ...widgetProps })
    }
    else if(wall[wallKeys.widgetType]===WIDGET_TYPE.BIG_PICTURE_REVIEW_TYPE){
      return GetBannerReviewCard({ ...widgetProps })
    }
    else if(wall[wallKeys.widgetType]===WIDGET_TYPE.GRAPHIC_REVIEW_TYPE){
      return GetGraphicCard({ ...widgetProps })
    }
    else if(wall[wallKeys.widgetType]===WIDGET_TYPE.QUOTE_REVIEW_TYPE){
      return GetCleanReviewCard({ ...widgetProps })
    }
    else if(wall[wallKeys.widgetType] === WIDGET_TYPE.QUOTE_TEXT_REVIEW_WIDGET_TYPE){
      return GetQuoteTextReviewCard({ ...widgetProps })
    }
    else if(wall[wallKeys.widgetType] === WIDGET_TYPE.AWARD_WIDGET_TYPE){
      return GetAwardReviewCard({ ...widgetProps })
    }
    else if(wall[wallKeys.widgetType] === WIDGET_TYPE.GREY_COLORED_WIDGET_TYPE){
      return GetGreyColoredCard({ ...widgetProps })
    }
  else
      return GetCarouselCard({ ...widgetProps })

  }
 
    return(
        <div >

  {
    firstBatch && firstBatch.length>0 &&
    <Marquee
      speed={40}
      id="marquee-first-container"
      gradient={false}
      pauseOnHover
      direction="left"
      style={{ overflowY: 'hidden', height: '100%' }}
    >
      {firstBatch.map((cardItem) => renderCardItem(cardItem))}
    </Marquee>
    }
    {
      secondBatch && secondBatch.length>0 &&
      <Marquee
      id="marquee-second-container"
      speed={40}
      gradient={false}
      pauseOnHover
      style={{ marginTop: rowSpacing, overflowY: 'hidden', height: '100%' }}
      direction="right"
      
    >
      {secondBatch.map((cardItem) => renderCardItem(cardItem))}
    </Marquee>
    }
    
  </div>
  )
};

export default MarqueeSlider;
